<!--
 * @Author: chenguanbin
 * @Date: 2020-06-01 14:14:22
 * @Desc: 传感器新增/修改
-->
<template>
  <h-page-container v-loading="loading">
    <h-page-header
      slot="pageHeader"
      :breadcrumb="breadcrumb"
      return-icon
      return-router="/device/sensor"
    />
    <h-layout direction="vertical">
      <el-scrollbar wrap-class="scrollbar-wrap">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-position="top"
          style="width: 480px;"
          content-width="480px"
        >
          <el-form-item label="所属设备" prop="channelSerial">
            <el-select v-if="!channelCode" v-model="form.channelSerial">
              <el-option
                v-for="(item, index) in sensorSerials"
                :key="`sensorSerial_${index}`"
                :label="item.deviceName"
                :value="item.deviceSerial"
              />
            </el-select>
            <el-input v-if="!!channelCode" v-model="form.deviceName" disabled />
          </el-form-item>
          <el-form-item label="传感器名称" prop="channelName">
            <el-input v-model="form.channelName" :maxlength="32" :tips="tips.channelName" />
          </el-form-item>
          <el-form-item label="传感器类型" prop="channelType">
            <el-select v-model="form.channelType">
              <el-option
                v-for="(item, index) in sensorTypes"
                :key="`sensorType_${index}`"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="通道号" prop="chanNum">
            <el-input v-model="form.chanNum" :maxlength="32" :tips="tips.chanNum" />
          </el-form-item>
          <el-form-item label="阈值最大值" prop="maxValue">
            <el-input v-model="form.maxValue" :maxlength="32" :tips="tips.maxValue" />
          </el-form-item>
          <el-form-item label="阈值最小值" prop="minValue">
            <el-input v-model="form.minValue" :maxlength="32" :tips="tips.minValue" />
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <h-page-footer inner-width="480px">
        <el-button type="primary" @click="handleSave">保存</el-button>
        <el-button @click="handleCancel">取消</el-button>
      </h-page-footer>
    </h-layout>
  </h-page-container>
</template>

<script>
import api from '@/api/deviceManage.js'

export default {
  name: 'SensorAlien',
  data() {
    return {
      loading: false,
      sensorSerials: [], // 序列号设备列表
      sensorTypes: [], // 传感器类型列表
      form: {
        channelSerial: '',
        channelName: '',
        channelType: '',
        chanNum: '',
        maxValue: '',
        minValue: ''
      },
      tips: {
        channelName: '1~32 位字符，不能包含\' / \\ : * ? " < > |这些特殊字符',
        chanNum: '1~32 位字符，由数字、字母、下划线、连接符组成',
        maxValue: '1~32 位数字',
        minValue: '1~32 位数字'
      },
      rules: {
        channelSerial: [
          { required: true, message: '请选择所属设备', type: 'string', trigger: 'blur' }
        ],
        channelName: [
          { required: true, message: '请输入传感器名称', type: 'string', trigger: 'blur' },
          {
            pattern: /^[^'/\\:*?"|<>]{1,32}$/,
            message: '请输入正确的传感器名称',
            trigger: 'blur'
          }
        ],
        channelType: [
          { required: true, message: '请选择传感器类型', type: 'string', trigger: 'blur' }
        ],
        chanNum: [
          { required: true, message: '请输入通道号', type: 'string', trigger: 'blur' },
          {
            pattern: /^[0-9a-zA-Z-_]{1,32}$/,
            message: '请输入正确的通道号',
            trigger: 'blur'
          }
        ],
        maxValue: [
          { required: true, message: '请输入阈值最大值', type: 'string', trigger: 'blur' },
          {
            pattern: /^[0-9\\.]{1,32}$/,
            message: '请输入正确的阈值',
            trigger: 'blur'
          }
        ],
        minValue: [
          { required: true, message: '请输入阈值最小值', type: 'string', trigger: 'blur' },
          {
            pattern: /^[0-9\\.]{1,32}$/,
            message: '请输入正确的阈值',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    // 组织编码
    orgId() {
      return this.$route.params.orgId
    },
    // 传感器编码（编辑时使用）
    channelCode() {
      return this.$route.params.channelCode
    }
  },
  async created() {
    if (!this.channelCode) {
      const { data: serials } = await api.querySensorSerial(this.orgId)
      this.sensorSerials = serials
    }
    const { data: types } = await api.queryDevicesByOrgCode()
    this.sensorTypes = types.list
  },
  mounted() {
    if (this.channelCode) {
      this.loading = true
      api
        .querySensor(this.channelCode)
        .then(({ data }) => {
          Object.assign(this.form, {
            channelSerial: data.channelSerial,
            channelName: data.channelName,
            deviceName: data.deviceName,
            channelType: data.channelType,
            chanNum: data.chanNum,
            maxValue: data.maxValue,
            minValue: data.minValue
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  methods: {
    /**
     * @author chenguanbin
     * @date 2020-06-05 17:27:20
     * @desc 点击保存按钮
     */
    handleSave() {
      this.$refs.form.validate(async (valid, invalidFields) => {
        if (valid) {
          this.loading = true
          const requestName = this.channelCode ? 'updateSensor' : 'addSensor'
          api[requestName]({
            channelCode: this.channelCode || undefined,
            orgId: this.orgId,
            ...this.form
          })
            .then(() => {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.$router.push({
                name: 'Sensor'
              })
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },

    /**
     * @author chenguanbin
     * @date 2020-06-05 17:27:29
     * @desc 点击取消按钮
     */
    handleCancel() {
      this.$router.push({
        name: 'Sensor'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin: 40px auto 0;
}
.h-page-footer {
  position: static;
  flex: none;
}
</style>
